import { Routes } from '@angular/router';

export default [
    // {
    //     path: '',
    //     loadComponent: () => import('../../shared/components/layout/simple/simple.component').then(m => m.SimpleLayoutComponent),
    //     canActivate: [ApplicationStartGuard, TranslationLoadGuard]
    // },
    {
        path: 'new',
        loadChildren: () => import('../../modules/eaglebe-frontoffice/frontoffice.routes')
    },
    {
        path: ':lang/new',
        loadChildren: () => import('../../modules/eaglebe-frontoffice/frontoffice.routes')
    }
] satisfies Routes;